import * as _ from 'underscore';
import { incrementRouterSpaceReactKey } from '../../app/actions/spaces/IncrementRouterSpaceReactKeyAction';
import { appStore } from '../../app/AppStore';
import { IServerUserInfo } from '../models/IServerUserInfo';
import { IUserSettings } from '../models/IUserSettings';
import { Module } from '../Module';
import { IGetTimeZonesResult, TimeZones } from '../../userSettings/services/TimeZones';
import { UserSettings } from '../resources/UserSettings';
import { ITimeZone } from '../ServerApi/types/ITimeZone';
import { ServerService } from '../services/ServerService';
import { ChangeTimeZoneNotification } from '../services/UserSettingsNotification';
import { HelpService } from '../../commonInfra/services/HelpService';

export interface IEditTimeZoneCtrls {
  save(): void;
  canSave(): void;
  isBusy(): void;
}

export interface IEditTimeZoneScope extends ng.IScope {
  controls: IEditTimeZoneCtrls;
  serverUser: IServerUserInfo;
  userSettings: IUserSettings;
  onSaveComplete(): any;

  timeZoneId: string;
  fullTimeZoneList: ITimeZone[];
  curatedTimeZoneList: ITimeZone[];
  model: { timeZoneId: string, showFullList: boolean };
  timeZoneSettingsLearnMoreHref: string;
}

export class EditTimeZoneCtrl {

  public static $inject = ['$scope', '$q', 'ChangeTimeZoneNotification',
    'UserSettings', 'ServerService'];
  $onInit: () => void;

  constructor($scope: IEditTimeZoneScope, $q: ng.IQService,
    changeTimeZoneNotification: ChangeTimeZoneNotification,
    userSettings: UserSettings, serverService: ServerService) {
    this.$onInit = () => {

      $scope.timeZoneSettingsLearnMoreHref = HelpService.getServerHelpUrlByCategory('subscription-timezone');

      // default to scope's timeZoneId, and show curated list
      $scope.model = {
        timeZoneId: $scope.timeZoneId,
        showFullList: false
      };

      // if the user's timeZoneId is null or invalid, we need to enable the save button using this boolean
      let nullOrInvalidTimeZone = false;

      // putting all these logic together
      // so we make only one request to server to get full list, curated list
      TimeZones.getAll().then((result: IGetTimeZonesResult) => {

        const serverTimeZone: ITimeZone = result.serverTimeZone;

        $scope.fullTimeZoneList = result.fullTimeZonesList;
        $scope.curatedTimeZoneList = result.curatedTimeZonesList;

        const timeZoneSpecifiedFromUserSettings = !!$scope.timeZoneId;
        if (timeZoneSpecifiedFromUserSettings) {
          const tzInCuratedList = _(result.curatedTimeZonesList).any(tz => tz.timeZoneId === $scope.timeZoneId);
          const tzInExtraList = _(result.extraTimeZonesList).any(tz => tz.timeZoneId === $scope.timeZoneId);

          if (!tzInCuratedList) {
            if (!tzInExtraList) {
              $scope.timeZoneId = serverTimeZone.timeZoneId;
              nullOrInvalidTimeZone = true;
            } else {
              $scope.model.showFullList = true;
            }
          }
        } else {
          $scope.timeZoneId = serverTimeZone.timeZoneId;
          nullOrInvalidTimeZone = true;
        }
        $scope.model.timeZoneId = $scope.timeZoneId;

        const serverTimeZoneInCuratedList = _(result.curatedTimeZonesList)
          .any(tz => tz.timeZoneId === serverTimeZone.timeZoneId);
        // when the user timeZoneId is null or invalid, and the server timeZoneId is not in the curated list
        // we need to show full list in this case
        if (nullOrInvalidTimeZone && !serverTimeZoneInCuratedList) {
          $scope.model.showFullList = true;
        }
      });

      let isBusy = false;
      // if timeZoneId is being changed from user's timeZoneId, or user's timeZoneId is null or Invalid
      // we enable the save button to be clickable, otherwise, the button is not clickable
      const isTimeZoneDirty = () => ($scope.model.timeZoneId !== $scope.timeZoneId) || nullOrInvalidTimeZone;
      const userIsViewingTheirOwnSettings = () => {
        return serverService.sessionUsername() === $scope.serverUser.username
          && serverService.sessionUserDomainName() === $scope.serverUser.domainName;
      };

      $scope.controls = {
        save: () => {
          isBusy = true;
          userSettings.updateUserLocalTimeZoneData(0, $scope.model.timeZoneId, true).then((result) => {
            // save completed successfully, so update the timeZoneId on the scope.
            $scope.timeZoneId = $scope.model.timeZoneId;
            if (userIsViewingTheirOwnSettings()) {
              serverService.refreshSessionInfo().then(() => {
                // wait to show toast so that they are rendered in the new timeZoneId
                appStore.dispatch(incrementRouterSpaceReactKey());
              });
            }
            // show toast right away since we are changing for another user
            if (result) {
              changeTimeZoneNotification.notify(result, $scope.serverUser.username);
            }
          }).finally(() => {
            isBusy = false;
          });
        },
        canSave: () => isTimeZoneDirty() && !isBusy,
        isBusy: () => isBusy
      };
    };
  }
}

Module.instance().controller('EditTimeZoneCtrl', EditTimeZoneCtrl);
